module.exports = __webpack_public_path__ + "img/home-hiw.50f89fc5.png";